// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__3hf8T","amount":"Amount_amount__2tCQJ","tip":"Amount_tip__3LPfv","tipHeader":"Amount_tipHeader__2fC1T","tipsWrap":"Amount_tipsWrap__2SQBz"};